import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicFormControls, BasicTextArea, BaasicButton } from 'core/components';

function FacilityOrderTemplateMissingDocumentNoteModalTemplate({ facilityOrderTemplateMissingDocumentNoteModalStore , t}) {
    const {
        missingDocument,
        form,
        modalParams
    } = facilityOrderTemplateMissingDocumentNoteModalStore;

    return (
        <section className='w--400--px'>
            <div className="modal__header">
                <h3 className='modal__header__title'>{missingDocument.name}</h3>
            </div>
            <div className="modal__body">
                <div className="form__group">
                    <BasicTextArea field={form.$('note')} />
                </div>
            </div>
            <div className='modal__footer'>
                <BaasicFormControls
                    form={form} 
                    onSubmit={form.onSubmit} 
                    disabled={form.submitting || form.validating} 
                    label="Submit"
                    className='btn btn--med btn--primary'
                />
                <BaasicButton
                    className='btn btn--med btn--light'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={() => modalParams.close()}
                />
            </div>
        </section>
    )
}
 
FacilityOrderTemplateMissingDocumentNoteModalTemplate.propTypes = {
    facilityOrderTemplateMissingDocumentNoteModalStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(FacilityOrderTemplateMissingDocumentNoteModalTemplate);
